import { timeFormat, format } from "d3";

export const alphabeticalSort = (a, b) => a.localeCompare(b);
export const snakeToSpaces = (n) => n.replace(/_/g, " ");
export const formatTimeYear = timeFormat("%Y");
export const formatTimeMonthYear = timeFormat("%m/%Y");
export const formatTimeDayMonthYear = timeFormat("%d/%m/%Y");
export const formatTimeReadableDayMonthYear = timeFormat("%b %Y");
export const formatTrimRound = format("~s");
export const formatThousands = format(",");

export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const isURL = (s) => !!s && s.startsWith("http");
